module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-SemiBold.4f35d88c.woff";